define(function(require, exports, module) {
    'use strict';

    var user = require('user');
    var ContactPreferenceView = require('replacers/contact-preferences/contact-preferences.view');

    module.exports = ContactPreferenceView.extend({

        handleSubmitPreferences: function(event) {
            const subscriptions = user.getSubscriptions().map(item => Object.assign({}, item));
            const formData = this.form.data();

            event.preventDefault();

            const parsedSubscriptions = subscriptions.map((item) => ({
                ...item,
                preference: Boolean(formData[item.channel])
            }));

            this.form.showLoading();
            user.setSubscriptions(parsedSubscriptions)
                .always(this.form.hideLoading.bind(this.form))
                .done(this.successRequest.bind(this))
                .fail(this.errorRequest.bind(this));
        }
    });
});
